export interface AdvancedFilterFieldInfo {
  name: string;
  displayLabel: string;
  dataType: string;
  hasLookup?: boolean;
  searchConfig?: any;
  options?: any[];
  supportedOperators?: ComparisonOperator[];
  operatorToFilterMap?: Map<string, string>;
  defaultValue?: any;
  readonly?: boolean;
  deletable?: boolean;
}

export const ComparisonOperator = {
  STARTS_WITH: { label: "Starts With", key: "STARTS_WITH" },
  EQ: { label: "Equals", key: "EQ" },
  NE: { label: "Not Equals", key: "NE" },
  IN: { label: "In", key: "IN" },
  NOT_IN: { label: "Not In", key: "NOT_IN" },
  IS_NULL: { label: "Is Null", key: "IS_NULL" },
  IS_NOT_NULL: { label: "Is Not Null", key: "IS_NOT_NULL" },
  LT: { label: "Less Than", key: "LT" },
  GT: { label: "Greater Than", key: "GT" },
  CONTAINS: { label: "Contains", key: "CONTAINS" }

} as const;
export type ComparisonOperator = typeof ComparisonOperator[keyof typeof ComparisonOperator];

export function getOperatorsByKey(operatorKeys: any[]) {
  if (operatorKeys && operatorKeys.length > 0) {
    const keySet = new Set(operatorKeys);
    return Object.values(ComparisonOperator).filter(operator => keySet.has(operator.key));
  }
  return null;
}
